import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'
import { trackMixpanel } from 'portal/store/mixpanel/actions'

export function useMixpanelEvents() {
  const dispatch = useDispatch()
  const { accountId, projectId } = useParams<{
    accountId: string
    projectId: string
  }>()

  return {
    trackOpen: useCallback(() => {
      dispatch(
        trackMixpanel('frontend_reports_open', {
          account_id: accountId,
          project_id: projectId,
          record_type: 'reports'
        })
      )
    }, [dispatch, accountId, projectId]),
    trackDownload: useCallback(
      (
        reportName: string,
        reportType: string,
        reportProjectId?: string,
        projectName?: string
      ) => {
        dispatch(
          trackMixpanel('frontend_reports_download', {
            account_id: accountId,
            project_id: reportProjectId || projectId,
            project_name: projectName,
            record_type: 'reports',
            report_name: reportName,
            report_type: reportType
          })
        )
      },
      [dispatch, accountId, projectId]
    )
  }
}
